(function(_){
    'use strict';
    _['RESTAURANT.KEY']='Página';
    _['RESTAURANT.CATEGORIES'] = 'Categorías';
    _['RESTAURANT.NO-CONTENT'] = 'Este módulo no tiene contenido.';
    _['RESTAURANT.NO-CONTENT-FOODS'] = 'Esta categoría no tiene contenido.';
    _['RESTAURANT.FROM'] = 'Desde';
    _['RESTAURANT.ADD'] = 'Añadir';
    _['RESTAURANT.VIEW_DETAIL'] = 'Ver detalles';
    _['RESTAURANT.GO-BACK-RESTAURANT'] = 'Volver a categorias';
    _['RESTAURANT.GO-BACK-CATEGORY'] = 'Volver a la categoría';
    _['RESTAURANT.PRICE'] = 'Precio';
    _['RESTAURANT.EXPAND'] = 'Ver descripción';
    _['RESTAURANT.COLLAPSE'] = 'Ocultar';

}(translations['es']));












// WEBPACK FOOTER //
// ./src/app/modules/restaurant/lang/restaurant-lang_es.js